export default __webpack_public_path__ + "static/media/Relacionamentos (Real Size).7d7258e1.svg";